import React from "react";
import { ITag, Label, TagPicker } from "office-ui-fabric-react";

import { HttpStatusCode } from 'app/shared';
import { mapArtistFromEntity, ArtistService } from "app/services/artist";
import { IActivityVariantArtist } from "app/services/activity-variant";

interface ArtistPickerState {
    loading: boolean;
    artists: IActivityVariantArtist[];
    selectedArtist: IActivityVariantArtist | null;
}

interface ArtistPickerProps {
    onChange: (artist: IActivityVariantArtist) => void;
    data: IActivityVariantArtist | null;
    disabled?: boolean;
    label?: string;
    language: string
    className?: string;
}

export default class ArtistPicker extends React.Component<ArtistPickerProps, ArtistPickerState> {

    state = {
        loading: false,
        artists: [] as IActivityVariantArtist[],
        selectedArtist: {} as IActivityVariantArtist
    };

    searchTimeout: number | NodeJS.Timeout = 0;

    onFilterChange = (filterText: string) => {

        clearTimeout(this.searchTimeout as number);

        if (!filterText ||
            filterText.length < 2) {
            return false;
        }

        return this.filterOnArtists(filterText);
    };

    filterOnArtists(filterText: string) {
        return new Promise((resolve, reject) => {
            this.searchTimeout = setTimeout(async () => {
                this.setState({
                    loading: true
                });
                const service = new ArtistService();
                const response = await service.getArtists({ descending: false, page: 1, pageSize: 100, title: filterText || "", language: this.props.language }) || [];

                if (response.status === HttpStatusCode.OK) {
                    const mapped = (response.data.attributes.list || []).map(item => mapArtistFromEntity(item))
                    resolve(mapped)
                }
                reject()
            }, 1000);
        })

    }

    onItemSelected = (item: ITag | IActivityVariantArtist) => {
        this.props.onChange(item as IActivityVariantArtist);
    };

    renderSuggestionsItem = (item: ITag | IActivityVariantArtist) => {
        const data = item as IActivityVariantArtist;

        return (
            <div className="sp-suggestion-item">
                <div className="sg-item-article">
                    <div className="name">{data.title}</div>
                </div>
            </div>
        );
    };

    renderItem = () => {
        if (!this.props.data || Object.keys(this.props.data).length <= 0) return null

        const item = this.props.data;

        return (
            <div key={item?.id} className="post-picker-item">
                {item.title}
                <div
                    onClick={() => this.setState({ selectedArtist: {} as IActivityVariantArtist }, () => this.props.onChange({} as IActivityVariantArtist))}
                    className="remove"
                >
                    <i className="icon-close1" />
                </div>
            </div>
        );
    };

    render() {
        const artist = this.props.data && Object.keys(this.props.data).length > 0 ? this.props.data : null;

        return (
            <div className={this.props.className ? `post-picker-container ${this.props.className}` : "post-picker-container"}>
                {this.props.label && (
                    <Label>{this.props.label}</Label>
                )}
                <TagPicker
                    inputProps={{
                        placeholder: "Arama Yapınız",
                    }}
                    onRenderSuggestionsItem={this.renderSuggestionsItem}
                    onRenderItem={(): any => this.renderItem()}
                    onResolveSuggestions={(filterText: string): any => this.onFilterChange(filterText)}
                    onItemSelected={(data): any => this.onItemSelected(data as ITag)}
                    className={artist ? "post-picker selected" : "post-picker"}
                    pickerSuggestionsProps={{
                        suggestionsHeaderText: "Tümünde Ara",
                        noResultsFoundText: "Sonuç Bulunamadı.",
                        className: "post-picker-suggestions"
                    }}
                    disabled={this.props.disabled}
                    selectedItems={artist ? [{ ...artist, key: artist?.id as string, name: artist?.title || "", }] : undefined}
                />
            </div>
        );
    }
}

